import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetMetrics' })
    .attrs({
        width: '100%',
    })``;
